import { formatMoney } from './money';
import type { MoneyString } from './money';

/**
 * A legenda do card "Saldo total" — RN-82.
 *
 * ================================================================
 * SALDO E DISPONÍVEL SÃO PERGUNTAS DIFERENTES
 * ================================================================
 *
 * "Quanto eu tenho" e "quanto eu ainda posso gastar" só coincidem para quem
 * está positivo e sem cheque especial. Para quem está negativo, a distância
 * entre os dois é a informação que importa:
 *
 *   Saldo total     − R$ 40.366,74     o que é seu
 *   Disponível      +  R$ 4.633,26     o que dá para gastar, com os limites
 *
 * Mostrar só o primeiro esconde que ainda há margem; mostrar só o segundo
 * esconde o tamanho da dívida. Os dois juntos respondem a pergunta inteira.
 *
 * ================================================================
 * SÓ APARECE QUANDO DIZ ALGO NOVO
 * ================================================================
 *
 * Sem limite de cheque especial e sem valor bloqueado, disponível é IGUAL ao
 * saldo. Repetir o mesmo número com outro nome ao lado não informa — treina a
 * pessoa a ignorar a legenda, e no dia em que os dois divergirem ela não olha.
 *
 * A comparação é entre as STRINGS que a API mandou, sem converter para número:
 * as duas saem da mesma formatação no backend, então iguais é iguais (ADR-0003).
 */
export function saldoHint(balance: {
  total: MoneyString;
  available: MoneyString;
  accounts_count: number;
}): string {
  const contas = balance.accounts_count === 1 ? '1 conta' : `${balance.accounts_count} contas`;

  if (balance.available === balance.total) {
    return contas;
  }

  return `${contas} · disponível ${formatMoney(balance.available)}`;
}
